import { useState } from "react";
import ProductFilterOpenButton from "./components/ProductFilterOpenButton";
import ProductFilterDrawer from "./components/ProductFilterDrawer";
import { useProductFilters } from "../productFilters/hooks/useProductFilters";
import PropTypes from "prop-types";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const ProductFilters = ({ className, facets, resultsCount, defaultOpenKey }) => {
	const { track } = useAnalytics();
	const [isOpen, setIsOpen] = useState(false);

	const toggleDrawer = () => {
		setIsOpen(prev => !prev);
		if (!isOpen) {
			track("product-filter-open");
		}
	};

	const {
		filters,
		setFilterValue,
		hasActiveFilters,
		removeFilterValue,
		resetFilters,
		selectedFiltersCount,
	} = useProductFilters(Object.keys(facets));

	return (
		<>
			<ProductFilterOpenButton
				className={className}
				onClick={toggleDrawer}
				selectedFiltersCount={selectedFiltersCount}
			/>

			<ProductFilterDrawer
				isOpen={isOpen}
				onClose={toggleDrawer}
				facets={facets}
				resultsCount={resultsCount}
				selectedFilters={filters}
				hasActiveFilters={hasActiveFilters}
				onFilterChange={setFilterValue}
				onResetFilters={resetFilters}
				onDeleteFilterOption={removeFilterValue}
				autoClose={true}
				defaultOpenKey={defaultOpenKey}
			/>
		</>
	);
};

ProductFilters.propTypes = {
	className: PropTypes.string,
	facets: PropTypes.objectOf(
		PropTypes.shape({
			labelKey: PropTypes.string.isRequired,
			selectionMode: PropTypes.oneOf(["single", "multiple"]).isRequired,
			values: PropTypes.arrayOf(
				PropTypes.shape({
					value: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					count: PropTypes.number.isRequired,
				})
			).isRequired,
		})
	),
	resultsCount: PropTypes.number.isRequired,
	defaultOpenKey: PropTypes.string,
};

export default ProductFilters;
